var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.slides
    ? _c(
        "vueper-slides",
        {
          class: {
            "no-shadow": !_vm.shadow,
            "small-navigation": _vm.smallNavigation,
          },
          attrs: {
            autoplay: _vm.isAutoplay,
            "visible-slides": _vm.visibleSlides,
            "slide-ratio": _vm.slideRatio,
            gap: _vm.gap,
            "fixed-height": _vm.fixedHeight,
            bullets: _vm.bullets,
          },
        },
        _vm._l(_vm.slides, function (slide, i) {
          return _c("vueper-slide", {
            key: i,
            class: _vm.slideClass,
            style: _vm.slideStyle,
            attrs: {
              image: slide[_vm.imageKey],
              title: slide.title,
              content: slide.content,
            },
            scopedSlots: _vm._u(
              [
                _vm.$scopedSlots.content
                  ? {
                      key: "content",
                      fn: function () {
                        return [
                          _vm._t("content", null, { index: i, slide: slide }),
                        ]
                      },
                      proxy: true,
                    }
                  : null,
              ],
              null,
              true
            ),
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }